const prefix = 'app';

export const APP_INIT = `${prefix}/APP_INIT`;
export const SHOW_ERROR = `${prefix}/SHOW_ERROR`;
export const SHOW_SUCCESS = `${prefix}/SHOW_SUCCESS`;
export const CLOSE_TOAST = `${prefix}/CLOSE_TOAST`;

export const SET_REGION = `${prefix}/SET_REGION`;
export const SET_CURRENCY = `${prefix}/SET_CURRENCY`;
